module.exports = __webpack_public_path__ + "img/product-can-not-access.3bc291ae.svg";